import { put, select } from 'redux-saga/effects';
import API from '@utils/api';
import { filterOutList } from '@utils/filters';
import UsersActions, { UsersSelectors } from './UsersRedux';
import logger from '@utils/logger';

export function* fetchUsers() {
  yield put(UsersActions.setUsersLoading(true));
  try {
    const {
      result: { users, pagination }
    } = yield API.fetchUsers();
    yield put(UsersActions.setUsers(users));
    yield put(UsersActions.setPagination(pagination));
    yield put(UsersActions.updateList(filterOutList(users)));
    yield put(UsersActions.setUsersLoading(false));
  } catch (err) {
    logger.error('err: ', err);
  }
}

export function* fetchUser(actions) {
  const { userId } = actions;
  const usersList = yield select(UsersSelectors.selectUsersList);
  let existingUser = usersList.find(item => +item.userID === +userId);
  if (!existingUser) {
    yield fetchUsers();
    const newList = yield select(UsersSelectors.selectUsersList);
    existingUser = newList.find(item => +item.userID === +userId);
  }
  yield put(UsersActions.setUsersLoading(true));

  try {
    if (!existingUser) {
      const { result: user } = yield API.fetchUser(userId);
      existingUser = user;
    }
    const { role } = existingUser;

    if (role === 'house_keeper') {
      const { result: roleInfo } = yield API.fetchUserInfo(userId, role);
      const { housekeeper } = roleInfo;
      existingUser = {
        ...housekeeper,
        roleInfo
      };
    }

    yield put(UsersActions.setUserData(existingUser));

    yield put(UsersActions.setUsersLoading(false));
  } catch (err) {
    logger.error('err: ', err);
  }
  yield put(UsersActions.setUsersLoading(false));
}
